<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in-up">
    <div class="w-full flex justify-between mb-4">
        <app-btn-back routeTo="/profile/details" icon="fa fa-arrow-left" btnText="Back to Profile"></app-btn-back>
        <div class="flex flex-row gap-4">
            <app-btn-action label="Refresh" (clicked)="refresh()" bgColor="bg-primary-500" textColor="text-white"
                icon="fa fa-refresh"></app-btn-action>
        </div>
    </div>

    <div class="mb-6">
        <h1 class="text-2xl font-bold text-gray-900 capitalize">
            My Certificates
        </h1>
        <p class="text-sm text-blueGray-500 mt-1">
            View and download certificates and awards earned across all communities and Sunday schools.
        </p>
    </div>

    <div class="w-full">
        @if (user?.uid) {
        <app-list-awards #awardsList [studentId]="user?.uid" [fetchAllGroups]="true" [showGroupName]="true"></app-list-awards>
        }
    </div>
</div>
